import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import bodyStyles from "./bodyStyles"

const Caps = styled.p(bodyStyles, `
  
  font-family: ProximaNova-Semibold;
  font-family: ${props => props.bold ? theme.font.bold : theme.font.semiBold};
  font-size: 14px;
  line-height: 19px;
  text-transform: uppercase;
  letter-spacing: .8px;
  a {
    color: ${theme.colors.grayscale.main};
    font-family: ProximaNova-Semibold;
    font-family: ${props => props.bold ? theme.font.bold : theme.font.semiBold};
    font-size: 14px;
    line-height: 19px;
    text-transform: uppercase;
    letter-spacing: .8px;
  }
`)
export default ({
  children,
  ...props
}) => (
    <Caps
      {...props}
    >
      {children}
    </Caps>
  )
